module.exports = __webpack_public_path__ + "static/img/Masterclass.cd229cc2.jpg";